// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file knop/ui/v1/model/servicetask.proto (package knop.ui.v1.model, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message knop.ui.v1.model.ServiceTask
 */
export class ServiceTask extends Message<ServiceTask> {
  /**
   * @generated from field: knop.ui.v1.model.ServiceTask.ServiceTaskType type = 1;
   */
  type = ServiceTask_ServiceTaskType.UNKNOWN;

  /**
   * @generated from field: knop.ui.v1.model.ServiceTask.ServiceTaskPlannedState is_planned = 2;
   */
  isPlanned = ServiceTask_ServiceTaskPlannedState.PLANNED_UNKNOWN;

  /**
   * @generated from field: bool is_feasible = 3;
   */
  isFeasible = false;

  /**
   * @generated from field: repeated knop.ui.v1.model.ServiceTask.ServiceTaskInfeasibilityReason infeasibility_reasons = 4;
   */
  infeasibilityReasons: ServiceTask_ServiceTaskInfeasibilityReason[] = [];

  constructor(data?: PartialMessage<ServiceTask>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.model.ServiceTask";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(ServiceTask_ServiceTaskType) },
    { no: 2, name: "is_planned", kind: "enum", T: proto3.getEnumType(ServiceTask_ServiceTaskPlannedState) },
    { no: 3, name: "is_feasible", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "infeasibility_reasons", kind: "enum", T: proto3.getEnumType(ServiceTask_ServiceTaskInfeasibilityReason), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ServiceTask {
    return new ServiceTask().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ServiceTask {
    return new ServiceTask().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ServiceTask {
    return new ServiceTask().fromJsonString(jsonString, options);
  }

  static equals(a: ServiceTask | PlainMessage<ServiceTask> | undefined, b: ServiceTask | PlainMessage<ServiceTask> | undefined): boolean {
    return proto3.util.equals(ServiceTask, a, b);
  }
}

/**
 * This will be dynamic in the future
 *
 * @generated from enum knop.ui.v1.model.ServiceTask.ServiceTaskType
 */
export enum ServiceTask_ServiceTaskType {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: CHECKING = 1;
   */
  CHECKING = 1,

  /**
   * @generated from enum value: CLEANING = 2;
   */
  CLEANING = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(ServiceTask_ServiceTaskType)
proto3.util.setEnumType(ServiceTask_ServiceTaskType, "knop.ui.v1.model.ServiceTask.ServiceTaskType", [
  { no: 0, name: "UNKNOWN" },
  { no: 1, name: "CHECKING" },
  { no: 2, name: "CLEANING" },
]);

/**
 * @generated from enum knop.ui.v1.model.ServiceTask.ServiceTaskPlannedState
 */
export enum ServiceTask_ServiceTaskPlannedState {
  /**
   * @generated from enum value: PLANNED_UNKNOWN = 0;
   */
  PLANNED_UNKNOWN = 0,

  /**
   * @generated from enum value: YES = 1;
   */
  YES = 1,

  /**
   * @generated from enum value: NO = 2;
   */
  NO = 2,

  /**
   * @generated from enum value: YES_FIXED = 3;
   */
  YES_FIXED = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(ServiceTask_ServiceTaskPlannedState)
proto3.util.setEnumType(ServiceTask_ServiceTaskPlannedState, "knop.ui.v1.model.ServiceTask.ServiceTaskPlannedState", [
  { no: 0, name: "PLANNED_UNKNOWN" },
  { no: 1, name: "YES" },
  { no: 2, name: "NO" },
  { no: 3, name: "YES_FIXED" },
]);

/**
 * @generated from enum knop.ui.v1.model.ServiceTask.ServiceTaskInfeasibilityReason
 */
export enum ServiceTask_ServiceTaskInfeasibilityReason {
  /**
   * @generated from enum value: REASON_UNKNOWN = 0;
   */
  REASON_UNKNOWN = 0,

  /**
   * @generated from enum value: DURATION_CONFLICT = 1;
   */
  DURATION_CONFLICT = 1,

  /**
   * @generated from enum value: NO_FACILITY_FOR_SERVICE_TASK = 2;
   */
  NO_FACILITY_FOR_SERVICE_TASK = 2,

  /**
   * @generated from enum value: NOT_IN_TIMEWINDOW_OF_FACILITY = 3;
   */
  NOT_IN_TIMEWINDOW_OF_FACILITY = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(ServiceTask_ServiceTaskInfeasibilityReason)
proto3.util.setEnumType(ServiceTask_ServiceTaskInfeasibilityReason, "knop.ui.v1.model.ServiceTask.ServiceTaskInfeasibilityReason", [
  { no: 0, name: "REASON_UNKNOWN" },
  { no: 1, name: "DURATION_CONFLICT" },
  { no: 2, name: "NO_FACILITY_FOR_SERVICE_TASK" },
  { no: 3, name: "NOT_IN_TIMEWINDOW_OF_FACILITY" },
]);

